import React from 'react'
import { Form, Row, Col } from 'react-bootstrap'
import RequirementValue from './requirement-value'

const Requirement = ({
    requirement = {},
    checked,
    onCheckChanged = () => {},
    value = '',
    onValueChange = () => {},
}) => {

    const renderRequirementValue = () => {
        if (!checked) {
            return null
        }
        return (
            <RequirementValue value={value} onChange={onValueChange} />
        )
    }

    return (
        <div>
            <div>
                <Form.Check
                    inline type='checkbox'
                    label={requirement.name}
                    checked={checked}
                    onChange={e => onCheckChanged(e.target.checked)}
                />
                {renderRequirementValue()}
            </div>
        </div>
    )
}

export default Requirement
